/* eslint-disable tsdoc/syntax */
import { SVGProps } from "react";
export const NoData1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 180 100"
    width="1em"
    height="1em"
    fill="none"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <rect width={112} height={19} x={38} y={68.744} fill="#F6F7F7" rx={4} />
    <path
      fill="#DDE1E5"
      d="M70.346 57.514a.97.97 0 0 1-.813-1.14 25.92 25.92 0 0 1 50.829-.123.97.97 0 0 1-.807 1.145l-11.16 1.82c-.545.089-1.055-.283-1.187-.819a12.612 12.612 0 0 0-24.511.06c-.13.536-.638.91-1.183.824l-11.168-1.767Z"
    />
    <path
      stroke="#EC948D"
      strokeLinecap="round"
      strokeWidth={2.245}
      d="m104.685 16.6-1.926 12.405"
    />
    <g stroke="#EC948D" strokeLinecap="round" strokeWidth={1.684}>
      <path d="m173.55 64.14.645 5.34M176.632 66.477l-5.52.667" />
    </g>
    <path
      stroke="#EC948D"
      strokeLinecap="round"
      strokeWidth={2.245}
      d="m114.63 27.743-3.549 2.02M90.9 20.812l3.833 6.813"
    />
    <path
      stroke="#C9D0D6"
      strokeWidth={1.123}
      d="M132.168 4.966c.726-.087 1.351.41 1.431 1.068.079.658-.41 1.29-1.135 1.379-.726.087-1.351-.41-1.431-1.07-.079-.657.409-1.289 1.135-1.377ZM71.663 14.081c1.234-.149 2.319.698 2.458 1.848.138 1.15-.714 2.23-1.948 2.378-1.234.15-2.319-.697-2.458-1.846-.139-1.15.714-2.23 1.948-2.38Z"
    />
    <path
      stroke="#EC948D"
      strokeWidth={1.684}
      d="M10.486 76.27c1.597-.193 2.995.903 3.173 2.382.179 1.479-.918 2.875-2.514 3.068-1.597.192-2.995-.902-3.174-2.381-.178-1.48.919-2.876 2.515-3.069Z"
    />
    <path
      stroke="#DDE1E5"
      strokeWidth={2.245}
      d="M23.636 26.27c1.96-.236 3.67 1.107 3.888 2.916.219 1.808-1.123 3.52-3.082 3.757-1.96.236-3.67-1.107-3.889-2.915-.218-1.809 1.123-3.52 3.083-3.758Z"
    />
  </svg>
);
